import React from 'react';
const modules = [{
  title: 'Clinical Assessment System™',
  description: 'Professional assessment templates, pain evaluations, ROM charts, strength testing forms, balance assessments, gait analysis sheets, and functional movement checklists—ready to streamline every patient evaluation.',
  color: 'bg-[#2E4A67]'
}, {
  title: 'Exercise Prescription Library™',
  description: 'A structured library of rehabilitation exercises covering the entire body, complete with progressions, regressions, coaching cues, and clinical guidance.',
  color: 'bg-[#5F7890]'
}, {
  title: 'Rehabilitation Programs™',
  description: 'Step-by-step rehabilitation frameworks for the most common musculoskeletal conditions with organized treatment progressions.',
  color: 'bg-[#7D8E82]'
}, {
  title: 'Treatment Planning Toolkit™',
  description: 'Professional planning tools including session templates, treatment plans, progression frameworks, goal-setting worksheets, and patient roadmaps.',
  color: 'bg-[#243C54]'
}, {
  title: 'Patient Education Resources™',
  description: 'Ready-to-use patient handouts covering pain education, posture, recovery, home exercises, and activity modification.',
  color: 'bg-[#C8A24A]'
}, {
  title: 'Clinical Documentation Kit™',
  description: 'Professional documentation templates including SOAP notes, evaluations, reassessments, progress notes, referrals, discharge summaries, and clinical checklists.',
  color: 'bg-[#B08F3A]'
}];
export function ModulesSection() {
  return <section className="py-14 px-4 sm:px-6 bg-brand-navy text-white" data-id="element-116">
      <div className="text-center mb-12" data-id="element-117">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-white mb-4 uppercase leading-tight" data-id="element-118">
          THE SOLUTION YOU'VE BEEN LOOKING FOR
        </h2>
        <p className="text-sm sm:text-base font-bold text-brand-gold mb-5 uppercase tracking-wide" data-id="element-119">
          ONE COMPLETE 6-IN-1 CLINICAL SYSTEM
        </p>
        <div className="inline-block bg-brand-gold/20 text-brand-gold px-5 py-2.5 rounded-lg mb-6 border border-brand-gold/30" data-id="element-120">
          <p className="font-bold text-sm tracking-wide uppercase" data-id="element-121">
            🩺 PHYSIO READY™ — Complete 6-in-1 Clinical Resource System
          </p>
        </div>
        <p className="text-sm sm:text-base text-white/80 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-122">
          Physio Ready™ is much more than a collection of templates and
          rehabilitation resources. It's a complete clinical system designed to
          help physical therapists evaluate patients faster, organize treatments
          more efficiently, simplify documentation, and deliver professional
          rehabilitation programs with confidence.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-123">
        {modules.map((module, i) => <div key={i} className="bg-brand-navy-dark p-6 rounded-xl flex flex-col gap-4 shadow-lg border border-white/5 hover:border-white/20 transition-colors" data-id="element-124">
            <div className="flex items-center gap-4" data-id="element-125">
              <div className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full font-black text-sm shadow-md text-white ${module.color}`} data-id="element-126">
                ✓
              </div>
              <h3 className="text-base font-bold leading-tight text-white uppercase" data-id="element-127">
                {module.title}
              </h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-128">
              {module.description}
            </p>
          </div>)}
      </div>
    </section>;
}